/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';
import { Popover, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { openCreateDownloadDialog } from '../../state/createDownloadDialog';
import { Icon, VaultButton } from '../../../Shared';
import { selectIsAnySelected } from '../../state/clipList';
import { selectIsUserExchangeAdmin, selectIsUserVaultSuperAdmin } from '../../../../state/user/userOrgRole';
import { stopClipPreview } from '../../state/currentReviewingClip';
import { getDownloadLink } from '../../../../api/vault/assetDetails';
import PublishOptions from './PublishOptions';
import toast, { superAdminToast } from '../../../../utils/toast';
import {
  ButtonContainer, HeaderContainer, HotKeysContainer, InfoContainer, RowContainer,
  TitleContainer,
} from './styles';

const ListOfHotKeys = [{
  hotkey: '1',
  description: 'Mark In',
}, {
  hotkey: '2',
  description: 'Mark Out',
}, {
  hotkey: 'Space',
  description: 'Pause and Play',
}, {
  hotkey: 'Left Arrow',
  description: 'One Frame Backward',
}, {
  hotkey: 'Right Arrow',
  description: 'One Frame Forward',
}, {
  hotkey: 'Shift + Left Arrow',
  description: 'One Second Backward',
}, {
  hotkey: 'Shift + Right Arrow',
  description: 'One Second Forward',
}, {
  hotkey: 'i',
  description: 'Alternate Mark In',
}, {
  hotkey: 'o',
  description: 'Alternate Mark Out',
}, {
  hotkey: 'j',
  description: 'Rewind 5 Seconds',
}, {
  hotkey: 'l',
  description: 'Fast Forward 5 Seconds',
}, {
  hotkey: 'k',
  description: 'Alternate Pause and Play',
}, {
  hotkey: 'Shift + o',
  description: 'Extend Last Edited Clip by 5 Seconds',
}];

class ClipListButtons extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false,
      id: undefined,
    };
    bindMethods(this);
  }

  handlePublish() {
    const { openCreateDownloadDialog, stopClipPreview } = this.props;
    openCreateDownloadDialog({ callback: null, message: 'Create' });
    stopClipPreview();
  }

  handleDownload() {
    const { openCreateDownloadDialog, stopClipPreview, isVaultSuperAdmin } = this.props;
    const cb = async (clip) => {
      const {
        data: { data: downloadLink },
      } = await getDownloadLink({ id: clip._id });
      superAdminToast(isVaultSuperAdmin, `Downloading "${clip.title}"`, { type: toast.TYPE.INFO });
      if (!window.open(downloadLink, '_blank')) {
        superAdminToast(isVaultSuperAdmin, 'Please disable pop up blocker to complete this action', { type: toast.TYPE.ERROR });
      }
    };

    openCreateDownloadDialog({ callback: cb, message: 'Download' });
    stopClipPreview();
  }
  handleOpenShortcuts(event) {
    this.setState({ anchorEl: event.currentTarget, open: Boolean(event.currentTarget) });
  }

  handleCloseShortcuts(event) {
    this.setState({ anchorEl: event.currentTarget, open: false, id: undefined });
  }

  render() {
    const {
      isAnySelected,
      isUserExchangeAdmin,
      isExchangeLiveEvent,
    } = this.props;

    return (
      <ButtonContainer id="ClipButtons">
        {(!isUserExchangeAdmin && !isExchangeLiveEvent) && (<PublishOptions />)}
        {!isExchangeLiveEvent && (
          <VaultButton
            id="ImportDownload"
            variant="plainOnPaper"
            disabled={!isAnySelected}
            onClick={isAnySelected ? this.handleDownload : null}
            width="auto"
          >
            Download
          </VaultButton>
        )}
        <VaultButton
          id="ImportPublish"
          variant="plainOnPaper"
          disabled={!isAnySelected}
          onClick={isAnySelected ? this.handlePublish : null}
          width="auto"
        >
          Create
        </VaultButton>
        <IconButton
          aria-label="info"
          aria-describedby={this.state.id}
          onClick={this.handleOpenShortcuts}
        >
          <InfoIcon />
        </IconButton>
        <Popover
          id={this.state.id}
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onClose={this.handleCloseShortcuts}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <HotKeysContainer>
            <InfoContainer>
              <HeaderContainer>
                <div>Helpful Shortcuts</div>
                <IconButton
                  onClick={this.handleCloseShortcuts}
                >
                  <CloseIcon />
                </IconButton>
              </HeaderContainer>
              <TitleContainer>
                <div>ACTION</div>
                <div>SHORTCUT</div>
              </TitleContainer>
              {ListOfHotKeys.map((hotKeyItem, index) => (
                <RowContainer key={index}>
                  <div>{hotKeyItem.description}</div>
                  <div>{hotKeyItem.hotkey}</div>
                </RowContainer>
              ))}
            </InfoContainer>
          </HotKeysContainer>
        </Popover>
      </ButtonContainer>
    );
  }
}

ClipListButtons.propTypes = {
  openCreateDownloadDialog: PropTypes.func.isRequired,
  stopClipPreview: PropTypes.func.isRequired,
  isAnySelected: PropTypes.bool.isRequired,
  isUserExchangeAdmin: PropTypes.bool.isRequired,
  isVaultSuperAdmin: PropTypes.bool.isRequired,
  isExchangeLiveEvent: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAnySelected: selectIsAnySelected(state),
  isUserExchangeAdmin: selectIsUserExchangeAdmin(state),
  isVaultSuperAdmin: selectIsUserVaultSuperAdmin(state),
  isExchangeLiveEvent: state.clipperMediaContent.isExchangeLiveEvent,
});

const mapDispatchToProps = {
  openCreateDownloadDialog,
  stopClipPreview,
  getDownloadLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClipListButtons);
